import angular from 'angular';
import generalFilters from './general.filter';

/**
 *  Module definition for simple general purpose filters
 */
const filters = angular.module('app.filters', []);

Object.keys(generalFilters).forEach((key) => {
	filters.filter(key, generalFilters[key]);
});

export default filters.name;


// WEBPACK FOOTER //
// ./src/app/misc/filters/filters.js